import React from "react"
import { FirmTeaser, FirmTeaserProps } from "../../firms"

export const FirmList = ({
  firms,
  title,
}: {
  firms: FirmTeaserProps[]
  title?: string
}) => {
  if (firms?.length === 0) {
    return null
  }

  return (
    <div>
      {title && <h2 className="mb-6 text-2xl font-bold text-night">{title}</h2>}
      <ul className="grid grid-cols-1 grid-flow-row gap-9 text-neutral-600 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {firms.map((hit) => (
          <li key={hit.url} className="lg:mx-0">
            <FirmTeaser {...hit} />
          </li>
        ))}
      </ul>
    </div>
  )
}
